import { jwtDecode } from "jwt-decode";
import AuthService from "../AuthService";
import featuresToggle from "../../lib/utils/featuresToggle";
import { hasLocalAccess } from "../../lib/configs";
import { AccessToken } from "../../lib/types/AccessToken";

export const getCheckTenant = () => {
  const token = AuthService.getCurrentUser();
  const parsedToken = token ? jwtDecode<AccessToken>(token) : undefined;
  const checkTenant = featuresToggle({
    value: parsedToken ? parsedToken.authorities?.includes("SYSTEM.WP") : false,
    alternativeValue: true,
    condition: hasLocalAccess("feature.roles"),
  });
  return checkTenant;
};
